// extracted by mini-css-extract-plugin
module.exports = {"uid":"u25b5398c"};